import { Box } from '@mui/material';
import { m } from '../framer-motion-rsc';

import { varContainer } from '../lib';

import type { BoxProps } from '@mui/material';
import type { MotionProps } from 'framer-motion';
import type { FC } from 'react';

type IProps = BoxProps & MotionProps;

export interface MotionContainerProps extends IProps {
  animate?: boolean;
  action?: boolean;
}

export const MotionContainer: FC<MotionContainerProps> = ({
  animate,
  action = false,
  children,
  ...other
}: MotionContainerProps) => {
  if (action) {
    return (
      <Box
        component={m.div}
        initial={false}
        animate={animate ? 'animate' : 'exit'}
        variants={varContainer()}
        {...other}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component={m.div}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={varContainer()}
      {...other}
    >
      {children}
    </Box>
  );
};
